export const TC_V4_DECIMAL_PLACES = 5;

export const roundTcV4Decimal = (value: unknown): number => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 0;
  return Number(numericValue.toFixed(TC_V4_DECIMAL_PLACES));
};

export const formatTcV4Decimal = (value: unknown): string => {
  if (value === undefined || value === null || value === "") return "";

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return "";

  return numericValue.toLocaleString("en-US", {
    maximumFractionDigits: TC_V4_DECIMAL_PLACES,
  });
};

export const tcV4NumberCell = ({ cell }: { cell: any }): string =>
  formatTcV4Decimal(cell.getValue());
